import VideoList from './VideoList'

export default VideoList
